module.exports = {"540127100":"工卡镇","540127200":"扎雪乡","540127201":"门巴乡","540127202":"扎西岗乡","540127203":"日多乡","540127204":"尼玛江热乡","540127205":"甲玛乡","540127206":"唐加乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540127.json
// module id = 2818
// module chunks = 0